var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"subtitle has-text-centered my-5"},[_c('i',{staticClass:"lni lni-information"}),_vm._v(" Nenhum "+_vm._s(_vm.entity)+" no sistema ")])])}
var staticRenderFns = []

export { render, staticRenderFns }